export const DELIVERY_ASR = 'asr';

export const DL_DASHBOARD = 'dashboard';
export const DL_ORDERS_LIST = 'orders';
export const DL_ORDER_DETAILS = 'details';
export const DL_ALERTS_LIST = 'alerts';
export const DL_ALERT_DETAILS = 'details';
export const DL_ALERT_NEW = 'new';
export const DL_CONTACT = 'contact';
export const DL_APPOINTMENTS_LIST = 'appointments';
export const DL_APPOINTMENTS_DETAILS = 'details';
